export const deepCopy = <T>(obj: T): T => {
    if (typeof window.structuredClone === "function") {
        return window.structuredClone(obj);
    } else {
        return JSON.parse(JSON.stringify(obj));
    }
}